function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class CustomerPortalModel {
    constructor(cp){
        _define_property(this, "customerPortalId", void 0);
        _define_property(this, "customerPortalName", void 0);
        _define_property(this, "createdAt", void 0);
        _define_property(this, "createdBy", void 0);
        _define_property(this, "pages", void 0);
        _define_property(this, "portalMeta", void 0);
        _define_property(this, "updatedAt", void 0);
        _define_property(this, "updatedBy", void 0);
        _define_property(this, "customerPortalThemeId", void 0);
        this.customerPortalId = cp.customerPortalId;
        this.customerPortalName = cp.customerPortalName;
        this.createdBy = cp.createdBy;
        this.createdAt = cp.createdAt;
        this.updatedBy = cp.updatedBy;
        this.updatedAt = cp.updatedAt;
        this.pages = cp.pages;
        this.portalMeta = cp.portalMeta;
        this.customerPortalThemeId = cp.customerPortalThemeId;
    }
}
